import React from 'react'
import { format } from "date-fns";
import { Thead, Tbody, Tr, Td, Text, Box, Center } from "@chakra-ui/react";
import { Table} from "@chakra-ui/react";
import { BiServer } from "react-icons/all";
import "./TouristByNationality.css";
import { touristByNationalityColumn } from '../../../constants/tableData';

function TouristByNationalityReportTable({data, filter}) {
  return (
    <>
        <Box style={{ position: "sticky", left: "0"}} w="100%" mb="10px">
            <Text textAlign="center" fontSize="25px" fontWeight="bold">Nationality Tourist Buying Ticket to Angkor</Text>
            <Text textAlign="center">Nationality Tourist Buying Ticket from {format(new Date(filter.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter.dateTo), "dd MMMM, yyyy")}</Text>
        </Box>
        
        {data?.length > 0 ? (
            <Table w="100%" size="sm" className="national-report-table" borderRight="1px solid black">
                <Thead className='national-report-thead'>
                <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='national-report-thead-tr1'>
                <Td textAlign="center" p="0">No</Td>
                <Td textAlign="center" p="0">DATE</Td>
                <Td textAlign="center" p="0">COUNTRY</Td>
                <Td textAlign="center" p="0">Under Age 12</Td>
                <Td textAlign="center" p="0">Age 12 - 25</Td>
                <Td textAlign="center" p="0">Age 26 - 59</Td>
                <Td textAlign="center" p="0">Age 60 Up</Td>
                <Td textAlign="center" p="0">TOTAL</Td>
                <Td textAlign="center" p="0">Female</Td>
                <Td textAlign="center" p="0">Male</Td>
                <Td textAlign="center" p="0">Total Gender</Td>
            </Tr>
                </Thead>

                <Tbody>
                    {data?.map((val, index) =>  {
                        return (
                            <Tr key={index} h="25px">
                                {touristByNationalityColumn.map((item, i) => {
                                    return (
                                        <Td 
                                            key={i} 
                                            w="150px" 
                                            textAlign={item.textAlign}
                                            height="35px" 
                                            py="0" 
                                            p="2px" 
                                            bg={(index===data.length-1) ? "#8497b0 !important" : "white" } 
                                            color={(index===data.length-1) ? "white !important" : "black" } 
                                        >
                                            {val[item.columnId]}
                                        </Td>
                                    )
                                })}
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
        ) : (
            <Center py="3" w="full" h="70vh" color="gray.400">
                <BiServer size="1.3rem" /> <Text fontSize="md">&nbsp;No data.</Text>
            </Center>
        )}
    </>
  )
}

export default TouristByNationalityReportTable
